import { createAction, props } from '@ngrx/store';
import { DeviceStats } from '../../shared/models/DeviceChartInfo';

export const loadDeviceStats = createAction(
  '[Stove] Load Device Stats',
  props<{ deviceId: string }>(),
);

export const loadDeviceStatsSuccess = createAction(
  '[Stove] Load Device Stats Success',
  props<{ deviceStats: DeviceStats }>(),
);

export const loadDeviceStatsFailure = createAction(
  '[Stove] Load Device Stats Failure',
  props<{ error: string | null }>(),
);

export const setDeviceStats = createAction(
  '[Stove] Set Device Stats',
  props<{ deviceStats: DeviceStats }>(),
);

export const clearDeviceStats = createAction('[Stove] Clear Device Stats');
